import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Scroll from 'react-custom-scroll';
import compose from '../../hoc/compose';
import Text from '../text/text';
import BaseModal from '../baseModal/baseModal';
import BaseModalHeader from '../baseModal/baseModalHeader';
import { dataHooks } from './constants';
var CustomModal = /*#__PURE__*/function (_React$PureComponent) {
  function CustomModal() {
    _classCallCheck(this, CustomModal);
    return _callSuper(this, CustomModal, arguments);
  }
  _inherits(CustomModal, _React$PureComponent);
  return _createClass(CustomModal, [{
    key: "_renderHeader",
    value: function _renderHeader() {
      var _this$props = this.props,
        title = _this$props.title,
        subtitle = _this$props.subtitle,
        onCloseButtonClick = _this$props.onCloseButtonClick,
        onHelpButtonClick = _this$props.onHelpButtonClick,
        subheaderContent = _this$props.subheaderContent;
      if (!title) {
        return null;
      }
      var className = classNames({
        'control-custom-modal-header': Boolean(title) || Boolean(subtitle) || Boolean(subheaderContent),
        'control-custom-modal-header-with-subheader': Boolean(subheaderContent)
      });
      return /*#__PURE__*/React.createElement(BaseModalHeader, {
        className: className,
        onCloseButtonClick: onCloseButtonClick,
        onHelpButtonClick: onHelpButtonClick
      }, /*#__PURE__*/React.createElement("div", {
        className: "control-custom-modal-header-text"
      }, /*#__PURE__*/React.createElement("div", {
        className: "control-custom-modal-title"
      }, /*#__PURE__*/React.createElement(Text, {
        dataHook: dataHooks.title,
        shouldTranslate: false,
        enableEllipsis: false,
        weight: "bold"
      }, title)), subtitle ? /*#__PURE__*/React.createElement("div", {
        className: "control-custom-modal-subtitle"
      }, /*#__PURE__*/React.createElement(Text, {
        dataHook: dataHooks.subtitle,
        shouldTranslate: false,
        enableEllipsis: false,
        skin: "secondary"
      }, subtitle)) : null), subheaderContent && /*#__PURE__*/React.createElement("div", {
        className: "control-custom-modal-header-subheader",
        "data-hook": dataHooks.subheaderContent
      }, subheaderContent));
    }
  }, {
    key: "_renderFooter",
    value: function _renderFooter() {
      var footerContent = this.props.footerContent;
      if (!footerContent) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHooks.footerContent,
        className: "control-custom-modal-footer"
      }, footerContent);
    }
  }, {
    key: "_renderContent",
    value: function _renderContent() {
      var _this$props2 = this.props,
        removeContentPadding = _this$props2.removeContentPadding,
        children = _this$props2.children;
      var contentWrapperClassName = classNames({
        'control-custom-modal-content-wrapper': true,
        'without-padding': removeContentPadding
      });
      return /*#__PURE__*/React.createElement(Scroll, {
        flex: "1"
      }, /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHooks.content,
        className: contentWrapperClassName
      }, children));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        dataHook = _this$props3.dataHook,
        getClassName = _this$props3.getClassName,
        theme = _this$props3.theme,
        sideActions = _this$props3.sideActions,
        footnote = _this$props3.footnote,
        title = _this$props3.title,
        subtitle = _this$props3.subtitle,
        subheaderContent = _this$props3.subheaderContent,
        onCloseButtonClick = _this$props3.onCloseButtonClick,
        onHelpButtonClick = _this$props3.onHelpButtonClick,
        primaryButtonText = _this$props3.primaryButtonText,
        primaryButtonProps = _this$props3.primaryButtonProps,
        primaryButtonOnClick = _this$props3.primaryButtonOnClick,
        primaryButtonTooltipContent = _this$props3.primaryButtonTooltipContent,
        secondaryButtonText = _this$props3.secondaryButtonText,
        secondaryButtonProps = _this$props3.secondaryButtonProps,
        secondaryButtonOnClick = _this$props3.secondaryButtonOnClick,
        removeHeaderPadding = _this$props3.removeHeaderPadding;
      return /*#__PURE__*/React.createElement(BaseModal, {
        dataHook: dataHook,
        theme: theme,
        sideActions: sideActions,
        footnote: footnote,
        onCloseButtonClick: onCloseButtonClick,
        onHelpButtonClick: onHelpButtonClick,
        primaryButtonText: primaryButtonText,
        primaryButtonProps: primaryButtonProps,
        primaryButtonOnClick: primaryButtonOnClick,
        primaryButtonTooltipContent: primaryButtonTooltipContent,
        secondaryButtonText: secondaryButtonText,
        secondaryButtonProps: secondaryButtonProps,
        secondaryButtonOnClick: secondaryButtonOnClick,
        className: classNames(getClassName('control-custom-modal'), {
          'without-header-padding': Boolean(removeHeaderPadding) && !title && !subtitle && !subheaderContent
        }),
        header: this._renderHeader(),
        footer: this._renderFooter()
      }, this._renderContent());
    }
  }]);
}(React.PureComponent);
CustomModal.displayName = 'CustomModal';
CustomModal.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** The content of the CustomModal */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** A css class to be applied to the component's root element */
  className: PropTypes.string,
  /** A global theme for the modal */
  theme: PropTypes.oneOf(['standard', 'destructive', 'premium']),
  /** The modal's title */
  title: PropTypes.string,
  /** The modal's subtitle */
  subtitle: PropTypes.string,
  /** side actions node, to be rendered to the left of the action buttons */
  sideActions: PropTypes.node,
  /** a node in header, rendered between title (or subtitle) and divider */
  subheaderContent: PropTypes.node,
  /** a footnote node, to be rendered at the very bottom of the modal */
  footnote: PropTypes.node,
  /** The custom content for modal. If set, the settings of primaryButton, secondaryButton and sideActions are dismissed*/
  footerContent: PropTypes.node,
  /** callback for when the close button is clicked */
  onCloseButtonClick: PropTypes.func,
  /** callback for when the help button is clicked */
  onHelpButtonClick: PropTypes.func,
  /** a text for the primary action button */
  primaryButtonText: PropTypes.string,
  /** Passed to the primary action button as props */
  primaryButtonProps: PropTypes.object,
  /** callback for when the secondary action button is clicked */
  primaryButtonOnClick: PropTypes.func,
  /** content for the primary action button tooltip */
  primaryButtonTooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element]),
  /** a text for the secondary action button */
  secondaryButtonText: PropTypes.string,
  /** Passed to the secondary action button as props */
  secondaryButtonProps: PropTypes.object,
  /** callback for when the secondary action button is clicked */
  secondaryButtonOnClick: PropTypes.func,
  /** Remove base padding for content */
  removeContentPadding: PropTypes.bool,
  /** Remove base padding for header */
  removeHeaderPadding: PropTypes.bool
};
CustomModal.defaultProps = {
  dataHook: 'CustomModal',
  theme: 'standard',
  removeContentPadding: false,
  removeHeaderPadding: false
};
export default compose(CustomModal);